<template>
    <div class="wc-radio">
        <el-row type="flex" justify="start" class="label">
            <div class="label">
                {{label}}:
            </div>
        </el-row>
        <div v-for="(option, index) in options">
            <div @click="radioCheck(option, index)">
            <el-row  class="option" :class="{'wc-select': option.checked}" type="flex" justify="start" >

                <el-col :span="20"  :key="option.option_id">
                    <el-row type="flex">
                    {{ option.option_name }}
                </el-row>
                    </el-col>
                <el-col :span="4">
                    <el-row type="flex" justify="end">
                    <i v-show="option.checked" class="el-icon-check"></i>
                </el-row>
                </el-col>
            </el-row>
            </div>
        </div>
    </div>
    </div>
</template>
<script>
export default {

    data() {
        return {
            checked: true
        }
    },

    props: ['label', 'options'],
    created() {
        //console.log(this.ischecked)
        let options = this.options
        for(let i=0; i < options.length; i++){
            if(i == 0){
                this.options[i].checked =true
                continue
            }
            this.options[i].checked =false
        }

    },
    methods: {
        radioCheck(option, index) {
            //console.log(option, index)
            let options = this.options
            for(let i = 0; i < options.length; i ++){
                let opt = options[i]
                opt.checked = false
                this.options.splice(i, 1,opt)
            }
            let op = option
            op.checked = true
            this.options.splice(index, 1, op)
            this.$emit('setReqdata',op)
        },
    },

}
</script>
<style>
.wc-radio {

    padding: 15px 0;
    color: #303133;
}

.wc-radio .label {
    color: #1f1f1f;
    font-style: bold;
    font-size: 14px;
}

.option {
    border-bottom: 1px solid #ebeef5;
    cursor: pointer;
    padding: 10px 0;
}

.wc-select {
    color: teal;
}

/*.lb:nth-child(1){
    border-top: 1px solid #ebeef5;;
}*/
</style>